import React, { useState } from "react"
import { Col, Collapse, Container, Row, Card, CardBody } from "reactstrap"
import moment from "moment"
import classnames from "classnames"
import Lightbox from "react-image-lightbox"

const Team_Screen = props => {
  const {
    teamscreen,
    sethandleAccordionteamscreen,
    handleAccordionteamscreen,
  } = props

  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(null)

  const handleOnclickAccordion = value => {
    if (handleAccordionteamscreen === value) {
      sethandleAccordionteamscreen(null)
    } else {
      sethandleAccordionteamscreen(value)
    }
  }

  const houstlistimage = teamscreen?.map(el => el?.screenLogs) || []
  const images =
    teamscreen?.length === 1
      ? houstlistimage[0]?.map(el => el.imagePath) || []
      : houstlistimage[handleAccordionteamscreen]?.map(el => el.imagePath) || []
  return (
    <React.Fragment>
      <div>
        <Container>
          <Row>
            {isGallery ? (
              <>
                <Lightbox
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={
                    images[(photoIndex + images.length - 1) % images.length]
                  }
                  enableZoom={true}
                  onCloseRequest={() => {
                    setisGallery(false)
                  }}
                  onMovePrevRequest={() => {
                    setphotoIndex(
                      (photoIndex + images.length - 1) % images.length
                    )
                  }}
                  onMoveNextRequest={() => {
                    setphotoIndex((photoIndex + 1) % images.length)
                  }}
                />
              </>
            ) : null}
            <Col xs="12" className="team-screen-log">
              <>
                {teamscreen?.length === 1 ? (
                  <>
                    {teamscreen?.map((screens, id) => (
                      <>
                        <div className="accordion p-2" id="accordion" key={id}>
                          <div className="accordion-item mb-2">
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                className={classnames(
                                  "accordion-button",
                                  "fw-medium",
                                  {
                                    collapsed: handleAccordionteamscreen === id,
                                  }
                                )}
                                type="button"
                                style={{ cursor: "pointer" }}
                              >
                                <div className="d-flex d-flex-justspace mobile_accordian">
                                  <div>
                                    Name :{" "}
                                    <span className="addposition">
                                      {screens?.userName}
                                    </span>
                                  </div>
                                </div>
                              </button>
                            </h2>
                            <Collapse
                              isOpen={handleAccordionteamscreen !== id}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <Row>
                                  {screens.screenLogs.map((img, ids) => (
                                    <Col xl="2" sm="4" key={"_col_" + ids}>
                                      <Card>
                                        <CardBody>
                                          {handleAccordionteamscreen !== id && (
                                            <>
                                              <div
                                                className="product-img position-relative d-flex"
                                                style={{
                                                  boxShadow:
                                                    "0px 5px 15px grey",
                                                }}
                                              >
                                                <img
                                                  src={img?.imagePath}
                                                  onClick={() => {
                                                    setisGallery(true)
                                                    setphotoIndex(ids)
                                                  }}
                                                  className="img-fluid mx-auto d-block"
                                                  style={{
                                                    borderRadius: "5px",
                                                  }}
                                                />
                                              </div>

                                              <div className="mt-2 text-center">
                                                {moment(
                                                  new Date(img.capturetime)
                                                ).format("HH:mm:ss")}
                                              </div>
                                            </>
                                          )}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            </Collapse>
                          </div>
                        </div>
                      </>
                    ))}
                  </>
                ) : (
                  <>
                    {teamscreen?.map((screens, id) => (
                      <div className="accordion p-2" id="accordion" key={id}>
                        <div className="accordion-item mb-2">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className={classnames(
                                "accordion-button",
                                "fw-medium",
                                {
                                  collapsed: handleAccordionteamscreen !== id,
                                }
                              )}
                              type="button"
                              onClick={() => handleOnclickAccordion(id)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="d-flex d-flex-justspace mobile_accordian">
                                <div>
                                  Name :{" "}
                                  <span className="addposition">
                                    {screens?.userName}
                                  </span>
                                </div>
                              </div>
                            </button>
                          </h2>

                          <Collapse
                            isOpen={handleAccordionteamscreen === id}
                            className="accordion-collapse"
                          >
                            <div className="accordion-body">
                              <Row>
                                {screens.screenLogs.map((img, ids) => (
                                  <Col xl="2" sm="4" key={"_col_" + ids}>
                                    <Card>
                                      <CardBody>
                                        {handleAccordionteamscreen === id && (
                                          <>
                                            <div
                                              className="product-img position-relative d-flex"
                                              style={{
                                                boxShadow: "0px 5px 15px grey",
                                              }}
                                            >
                                              <img
                                                src={img?.imagePath}
                                                onClick={() => {
                                                  setisGallery(true)
                                                  setphotoIndex(ids)
                                                }}
                                                className="img-fluid mx-auto d-block"
                                                style={{
                                                  borderRadius: "5px",
                                                }}
                                              />
                                            </div>

                                            <div className="mt-2 text-center">
                                              {moment(
                                                new Date(img.capturetime)
                                              ).format("HH:mm:ss")}
                                            </div>
                                          </>
                                        )}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                ))}
                              </Row>
                            </div>
                          </Collapse>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </>
              {/* {teamscreen?.length == 0 && (
                <div className="text-center">
                  No Records Found
                </div>
              )} */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Team_Screen
